import React from "react";

const BrainIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 14.9974V4.16406"
        stroke="#379fff"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 10.8333C11.779 10.6226 11.1457 10.1839 10.695 9.58292C10.2443 8.98198 10.0005 8.25117 10 7.5C9.99955 8.25117 9.7557 8.98198 9.305 9.58292C8.8543 10.1839 8.221 10.6226 7.5 10.8333"
        stroke="#379fff"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.665 5.41417C14.8568 5.08208 14.9695 4.71032 14.9946 4.32767C15.0197 3.94501 14.9565 3.56171 14.8097 3.20742C14.663 2.85312 14.4367 2.53734 14.1484 2.28449C13.8601 2.03164 13.5175 1.8485 13.1471 1.74925C12.7766 1.65 12.3884 1.63729 12.0123 1.7121C11.6361 1.78692 11.2823 1.94726 10.9781 2.18071C10.6738 2.41416 10.4274 2.71448 10.2578 3.05841C10.0882 3.40235 9.99998 3.78069 10 4.16417C10 3.78069 9.91181 3.40235 9.74222 3.05841C9.57262 2.71448 9.32617 2.41416 9.02194 2.18071C8.71771 1.94726 8.36386 1.78692 7.98775 1.7121C7.61164 1.63729 7.22336 1.65 6.85294 1.74925C6.48253 1.8485 6.13992 2.03164 5.85161 2.28449C5.5633 2.53734 5.33702 2.85312 5.19028 3.20742C5.04353 3.56171 4.98026 3.94501 5.00536 4.32767C5.03046 4.71032 5.14324 5.08208 5.335 5.41417"
        stroke="#379fff"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9971 4.27344C15.4869 4.39938 15.9417 4.63515 16.3269 4.96286C16.7121 5.29058 17.0177 5.70167 17.2205 6.16498C17.4234 6.62829 17.5181 7.13168 17.4976 7.63703C17.4771 8.14238 17.3418 8.63643 17.1021 9.08177"
        stroke="#379fff"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 15.0012C15.7338 15.0012 16.447 14.7591 17.0291 14.3124C17.6112 13.8657 18.0297 13.2394 18.2196 12.5307C18.4095 11.8219 18.3603 11.0703 18.0795 10.3924C17.7987 9.71448 17.3021 9.14816 16.6667 8.78125"
        stroke="#379fff"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6388 14.5703C16.6972 15.0222 16.6624 15.4812 16.5364 15.9191C16.4105 16.3569 16.1961 16.7643 15.9065 17.1161C15.6169 17.4679 15.2583 17.7565 14.8528 17.9643C14.4473 18.172 14.0035 18.2944 13.5489 18.3239C13.0942 18.3534 12.6383 18.2894 12.2094 18.1358C11.7804 17.9822 11.3875 17.7423 11.0549 17.4309C10.7223 17.1196 10.457 16.7433 10.2755 16.3254C10.094 15.9075 10.0002 15.4568 9.99967 15.0011C9.99919 15.4568 9.9053 15.9075 9.72381 16.3254C9.54232 16.7433 9.27708 17.1196 8.94447 17.4309C8.61186 17.7423 8.21895 17.9822 7.79 18.1358C7.36104 18.2894 6.90515 18.3534 6.45049 18.3239C5.99582 18.2944 5.55203 18.172 5.14652 17.9643C4.74101 17.7565 4.3824 17.4679 4.09283 17.1161C3.80325 16.7643 3.58887 16.3569 3.46291 15.9191C3.33696 15.4812 3.3021 15.0222 3.36051 14.5703"
        stroke="#379fff"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.00018 15.0012C4.26643 15.0012 3.55319 14.7591 2.97107 14.3124C2.38895 13.8657 1.97049 13.2394 1.78058 12.5307C1.59067 11.8219 1.63992 11.0703 1.92069 10.3924C2.20147 9.71448 2.69808 9.14816 3.33351 8.78125"
        stroke="#379fff"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.00228 4.27344C4.51245 4.39938 4.0577 4.63515 3.67247 4.96286C3.28725 5.29058 2.98164 5.70167 2.77882 6.16498C2.57599 6.62829 2.48125 7.13168 2.50177 7.63703C2.52229 8.14238 2.65754 8.63643 2.89728 9.08177"
        stroke="#379fff"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BrainIcon;
